import { Tooltip, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const features = [
  {
    id: 1,
    isDisabled: false,
    Component: (
      <>
        <Text>Access to all content</Text>
        <br />
        <Text className="small">
          Over 50 units with music videos, games, stories and much more!
        </Text>
      </>
    ),
  },
  {
    id: 2,
    isDisabled: false,
    Component: (
      <Text>
        Integration with <strong>Clever, Google Classroom</strong> and{' '}
        <strong>ClassLink</strong>
      </Text>
    ),
  },
  {
    id: 3,
    disabled: false,
    Component: <Text>Individual student accounts</Text>,
  },
  {
    id: 4,
    isDisabled: false,
    Component: (
      <Text>Keep track of student&apos;s work with detailed analytics</Text>
    ),
  },
  {
    id: 5,
    isDisabled: false,
    Component: (
      <>
        <Text>Assign tasks to students</Text>
        <br />
        <Text className="small">
          Over 150 ready to assign tasks{' '}
          <Tooltip
            title={
              <>
                <p>
                  You will have access to over 150 already created tasks that
                  you can assign to students in just a couple of clicks.
                </p>
                <p>
                  From your dashboard you can monitor student progress and see
                  the % of right and wrong answers for each student.
                </p>
                <p>
                  You will save hours of prep time and your students will be
                  more engaged.
                </p>
              </>
            }
          >
            <InfoCircleOutlined className="info" />
          </Tooltip>
        </Text>
      </>
    ),
  },
  {
    id: 6,
    isDisabled: false,
    Component: (
      <Text>
        Customize the curriculum for each class{' '}
        <Tooltip
          title={
            <p>
              You have control over what content each class can access. For each
              class you can unblock content little by little or all at once
            </p>
          }
        >
          <InfoCircleOutlined className="info" />
        </Tooltip>
      </Text>
    ),
  },
];

export default features;
